// removed by extract-text-webpack-plugin
module.exports = {"wrap":"pages-MyLoads-wrap","notLogin":"pages-MyLoads-notLogin","contentWrapper":"pages-MyLoads-contentWrapper","notFoundWrapper":"pages-MyLoads-notFoundWrapper","loadingWrapper":"pages-MyLoads-loadingWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/MyLoads/index.css
// module id = 1814
// module chunks = 0